import { TranslocoPipe, provideTranslocoScope, translate } from '@jsverse/transloco';
import { Component, Input, OnInit } from '@angular/core';
import { ListPageColumnComponent } from 'design-system';
import { ProductStock } from '../../../interfaces/product.model';

@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-availability-chip',
  imports: [TranslocoPipe, ],
  templateUrl: './availability-chip.html',
  styleUrl: './availability-chip.scss',
})
export class AvailabilityChip extends ListPageColumnComponent implements OnInit {
  @Input() stock: ProductStock | null | undefined;

  get indicatorClass(): string {
    return `availability-indicator--${this.stock?.availability?.toLowerCase() ?? 'unknown'}`;
  }

  get iconClass(): string {
    switch (this.stock?.availability) {
      case 'HIGH':
        return 'fa-solid fa-circle-check';
      case 'LOW':
        return 'fa-solid fa-circle-exclamation';
      case 'NONE':
        return 'fa-solid fa-circle-exclamation';
      default:
        return 'fa-solid fa-circle-question';
    }
  }

  get label(): string {
    let availabilityLabel: string;

    switch (this.stock?.availability) {
      case 'HIGH':
        availabilityLabel = translate<string>('products.ui.disponibilitaAlta');
        break;
      case 'LOW':
        availabilityLabel = translate<string>('products.ui.disponibilitaBassa');
        break;
      case 'NONE':
        availabilityLabel = translate<string>('products.ui.nonDisponibile');
        break;
      default:
        availabilityLabel = translate<string>('products.ui.disponibilitaNonRicevuta');
    }

    return this.hasQuantity
      ? `${availabilityLabel}, quantità ${this.stock?.quantity}`
      : availabilityLabel;
  }

  get hasQuantity(): boolean {
    return this.stock?.quantity !== null
      && this.stock?.quantity !== undefined
      && this.stock.quantity !== 0;
  }

  ngOnInit() {
    if (this.itemData && this.infoColumn) {
      this.stock = this.itemData[this.infoColumn.columnNameDef];
    }
  }
}
